import { useEffect, useRef, useState, type ReactNode } from 'react';

export function CcmMenu({ trigger, children }: { trigger: ReactNode; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div ref={ref} className="relative">
      <div onClick={() => setOpen((value) => !value)}>{trigger}</div>
      {open && (
        <div className="absolute right-0 top-full z-[120] mt-1 min-w-[11rem] overflow-hidden rounded-lg border border-[#c6c5d3] bg-white py-1.5 shadow-[0_8px_24px_rgb(0_0_0_/_0.12)]">
          <div onClick={() => setOpen(false)}>{children}</div>
        </div>
      )}
    </div>
  );
}

export function CcmMenuLink({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a href={href} className="ccm-menu-item">
      {children}
    </a>
  );
}

export function CcmMenuButton({
  children,
  onClick,
  danger,
}: {
  children: ReactNode;
  onClick?: () => void;
  danger?: boolean;
}) {
  return (
    <button type="button" className={`ccm-menu-item ${danger ? 'ccm-menu-item--danger' : ''}`} onClick={onClick}>
      {children}
    </button>
  );
}

export function CcmMenuDivider() {
  return <hr className="ccm-menu-divider" role="presentation" />;
}
